export default "__VITE_ASSET__xgTfbxpg__"